export default "__VITE_ASSET__CKYgvRKm__"